// src/components/Loader.jsx
import React from 'react';
import './Loader.css'; // External CSS file

const Loader = () => {
  return <div className="loader"></div>;
};

export default Loader;
